// Košík v hlavičce (cartCounter.js).
export default {
  eyebrow: 'Košík',
  empty: 'Prázdný',
};
